"use strict";
/**
 * @file Contains the logic dealing with enabling, disabling, and managing animation.
 * @see $dyn.ui.animation
 *
 * @copyright Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var $dyn;
(function ($dyn) {
    var ui;
    (function (ui) {
        /** Internally used flag for indicating if animation is enabled. */
        var animsEnabled = true;
        /** A reference to the animation-killing CSS rule. */
        var styleElem = null;
        /** The ID of the style that is applied to kill animation. */
        var styleElemId = "disable-animation";
        /** A reference to the input cursor killing CSS rule. */
        var styleElemInputCursor = null;
        /** The ID of the style that is applied to kill input cursor. */
        var styleElemIdInputCursor = "disable-inputCursor";
        /** Contains methods for enabling, disabling and managing animation. */
        var animation;
        (function (animation) {
            /** Indicates the current state of animations (enabled or disabled). */
            animation.enabled = $dyn.computed(
            // Getter
            function () {
                return animsEnabled;
            }, 
            // Setter
            function (value) {
                if (value) {
                    this.enableAnimation();
                }
                else {
                    this.disableAnimation();
                }
            });
            /**
             * Enables animations.
             */
            function enableAnimation() {
                if (!animsEnabled) {
                    animsEnabled = true;
                    var elem = document.getElementById(styleElemId);
                    while (elem) {
                        // It should not be possible, but if the element got added multiple times we
                        // need to remove every instance of the style.
                        elem.remove();
                        elem = document.getElementById(styleElemId);
                    }
                }
            }
            animation.enableAnimation = enableAnimation;
            /**
             * Disables animation.
             */
            function disableAnimation() {
                if (animsEnabled) {
                    animsEnabled = false;
                    if (!styleElem) {
                        styleElem = document.createElement("style");
                        styleElem.id = styleElemId;
                        styleElem.type = "text/css";
                        styleElem.innerHTML =
                            "*,*::before,*::after{\
                                -webkit-animation-duration: 0s !important;\
                                -webkit-transition-duration: 0s !important;\
                                -moz-animation-duration: 0s !important;\
                                -moz-transition-duration: 0s !important;\
                                -ms-animation-duration: 0s !important;\
                                -ms-transition-duration: 0s !important;\
                                -o-animation-duration: 0s !important;\
                                -o-transition-duration: 0s !important;\
                                animation-duration: 0s !important;\
                                transition-duration: 0s !important;\
                                -webkit-transition-delay: 0s !important;\
                                transition-delay: 0s !important;\
                                -webkit-animation-delay: 0s !important;\
                                animation-delay: 0s !important;\
                            }";
                    }
                    document.getElementsByTagName("head")[0].appendChild(styleElem);
                }
            }
            animation.disableAnimation = disableAnimation;
            /**
             * Disables Input Cursor for vrtt tests.
             */
            function disableInputCursor() {
                if (!styleElemInputCursor) {
                    styleElemInputCursor = document.createElement("style");
                    styleElemInputCursor.id = styleElemIdInputCursor;
                    styleElemInputCursor.type = "text/css";
                    styleElemInputCursor.innerHTML =
                        "*{\
                            caret-color: transparent !important;\
                        }";
                }
                document.getElementsByTagName("head")[0].appendChild(styleElemInputCursor);
            }
            animation.disableInputCursor = disableInputCursor;
        })(animation = ui.animation || (ui.animation = {}));
        if ($dyn.util.location.query.disableanimation) {
            $dyn.ui.animation.disableAnimation();
            $dyn.flags.disableAnimations = true;
        }
        if ($dyn.util.location.query.enableFocusTooltip === "true") {
            $dyn.flags.enableFocusTooltip = true;
        }
        if ($dyn.util.location.query.disableFocusReactions) {
            $dyn.ui.animation.disableInputCursor();
            $dyn.flags.disableFocusReactions = true;
            $dyn.flags.enableFocusTooltip = false;
        }
    })(ui = $dyn.ui || ($dyn.ui = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Animation.js.map
